module.exports = __webpack_public_path__ + "static/media/cat6.33efa085.png";